import React from 'react';
import { Global, SerializedStyles } from '@emotion/react';
import emotionNormalize from 'emotion-normalize';
import { stylesCommon } from './styles.common';
import { stylesDesktop } from './styles.desktop';
import { stylesMobile } from './styles.mobile';
import { personalOfferStyles } from './personal-offer';
import {
  inter,
  dewi,
  proxima,
  geometria,
  defaultStylesInter,
  defaultStylesDewi,
  defaultStylesProxima,
  defaultStylesGeometria
} from '../Fonts';

export type Font = 'inter' | 'dewi' | 'proxima' | 'geometria';

interface Props {
  fonts?: Font[];
  defaultFont?: Font;
  styles?: SerializedStyles[];
}

const getFonts = (fonts: Font[], defaultFont: Font) => {
  const listStyles: SerializedStyles[] = fonts.map(font => {
    switch (font) {
      case 'inter':
        return inter;
      case 'dewi':
        return dewi;
      case 'proxima':
        return proxima;
      case 'geometria':
        return geometria;
      default:
        return inter;
    }
  });

  switch (defaultFont) {
    case 'inter':
      listStyles.push(defaultStylesInter);
      break;
    case 'dewi':
      listStyles.push(defaultStylesDewi);
      break;
    case 'proxima':
      listStyles.push(defaultStylesProxima);
      break;
    case 'geometria':
      listStyles.push(defaultStylesGeometria);
      break;
    default:
      listStyles.push(defaultStylesInter);
  }

  return listStyles;
};

export function GlobalStylesResponsive(props: Props) {
  const { fonts = ['inter', 'dewi'], defaultFont = 'inter', styles = [] } = props;
  return (
    <Global styles={[emotionNormalize, ...getFonts(fonts, defaultFont), stylesCommon, ...styles]} />
  );
}

export function GlobalStylesDesktop(props: Props) {
  const { fonts = ['inter', 'dewi'], defaultFont = 'inter', styles = [] } = props;
  return (
    <Global
      styles={[
        emotionNormalize,
        ...getFonts(fonts, defaultFont),
        stylesCommon,
        stylesDesktop,
        personalOfferStyles,
        ...styles
      ]}
    />
  );
}

export function GlobalStylesMobile(props: Props) {
  const { fonts = ['inter', 'dewi'], defaultFont = 'inter', styles = [] } = props;
  return (
    <Global
      styles={[
        emotionNormalize,
        ...getFonts(fonts, defaultFont),
        stylesCommon,
        stylesMobile,
        personalOfferStyles,
        ...styles
      ]}
    />
  );
}
